// FILE: src/api/paymentApi.js
import { api } from "./http";

/**
 * Create Razorpay order through backend.
 *
 * POST /api/payment/createOrder
 * body: { amount, userId?, userEmail?, userPhone? }
 */
export async function createOrder({ amount, userId, userEmail, userPhone }) {
  const payload = {
    amount: Number(amount) || 0,
    userId: typeof userId === "number" ? userId : null,
    userEmail: userEmail || null,
    userPhone: userPhone || null,
  };

  const res = await api("/api/payment/createOrder", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`createOrder failed (${res.status}): ${text}`);
  }

  return res.json();
}

/**
 * Verify Razorpay payment.
 *
 * NEW FLOW:
 *  POST /api/payment/verify
 *  body: { paymentId, order_id, payment_id, signature, userId?, phoneNumber?, userEmail? }
 *
 * LEGACY ONLY:
 *  bookingIds: [..]  // will attach those final Booking rows
 */
export async function verifyPayment({
  paymentId,
  order_id,
  payment_id,
  signature,
  userId,
  userEmail,
  phoneNumber,
  bookingIds, // optional legacy
}) {
  const payload = {
    paymentId: paymentId || null,
    order_id,
    payment_id,
    signature,

    userId: typeof userId === "number" ? userId : null,
    userEmail: userEmail || null,
    phoneNumber: phoneNumber || null,

    // ✅ legacy only (send ONLY if you are in old flow)
    bookingIds: Array.isArray(bookingIds) && bookingIds.length ? bookingIds : undefined,
  };

  const res = await api("/api/payment/verify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  let body;
  try {
    body = await res.json();
  } catch {
    body = { success: false, message: `HTTP ${res.status}` };
  }
  return body;
}

export async function reconcilePayment({
  paymentId,
  order_id,
  userId,
  userEmail,
  phoneNumber,
  bookingIds,
}) {
  const payload = {
    paymentId: paymentId || null,
    order_id,
    userId: typeof userId === "number" ? userId : null,
    userEmail: userEmail || null,
    phoneNumber: phoneNumber || null,
    bookingIds: Array.isArray(bookingIds) && bookingIds.length ? bookingIds : undefined,
  };

  const res = await api("/api/payment/reconcile", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  let body;
  try {
    body = await res.json();
  } catch {
    body = { success: false, message: `HTTP ${res.status}` };
  }
  return body;
}
